module.exports = __webpack_public_path__ + "img/profile.444d3b40.svg";